// extracted by mini-css-extract-plugin
export var infoRow = "_s7-2";
export var labelContainer = "_s7-0";
export var rightInfo = "_s7-1";